// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { mathAbs } from "@nevware21/ts-utils";
import { _DYN_CONCAT, _DYN_LENGTH } from "../../__DynamicConstants";
// (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
var MIN_INPUT_LENGTH = 8;
// We're using 32 bit math, hence max value is (2^31 - 1)
var INT_MAX_VALUE = 2147483647;
export function getHashCodeScore(key) {
    var score = 0;
    var input = key;
    if (input) {
        while (input[_DYN_LENGTH /* @min:%2elength */] < MIN_INPUT_LENGTH) {
            input = input[_DYN_CONCAT /* @min:%2econcat */](input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input[_DYN_LENGTH /* @min:%2elength */]; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        score = mathAbs(hash) / INT_MAX_VALUE;
    }
    return score * 100;
}
//# sourceMappingURL=HashCodeScoreGenerator.js.map